import React from "react";

export const questionBlobFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.47328 2 2 6.47254 2 12V21.2188C2 21.6502 2.34977 22 2.78125 22H12C17.5267 22 22 17.5275 22 12C22 6.47328 17.5275 2 12 2ZM12 20.4375H3.5625V12C3.5625 7.33684 7.33621 3.5625 12 3.5625C16.6632 3.5625 20.4375 7.33621 20.4375 12C20.4375 16.6632 16.6638 20.4375 12 20.4375Z"
        fill="currentColor"
      />
      <path
        d="M3 11.0005C3.83333 7.50049 7.5 1.20049 15.5 4.00049C18 5.00059 22.3999 8.80065 20 16.0005C19.3331 17.334 17.0997 20.2006 13.5 21.0005H3V11.0005ZM11.1426 15.5327C10.5045 15.5329 9.98732 16.0498 9.9873 16.688C9.9873 17.3261 10.5045 17.844 11.1426 17.8442H11.1768C11.8149 17.844 12.332 17.3262 12.332 16.688C12.332 16.0498 11.8149 15.5329 11.1768 15.5327H11.1426ZM12.041 8.00049C11.361 8.00049 10.7777 8.12843 10.292 8.38525C9.80636 8.63317 9.43967 8.97391 9.19238 9.40771C9.11704 9.54482 9.05466 9.68773 9.00488 9.83545C8.81827 10.3897 9.32536 10.8696 9.91016 10.8696H10.2021C10.6395 10.8694 10.9452 10.4567 11.2461 10.1392C11.4227 9.95325 11.6695 9.85993 11.9873 9.85986C12.2788 9.85986 12.509 9.94836 12.6768 10.1255C12.8533 10.2938 12.9414 10.5285 12.9414 10.8296C12.9414 11.2813 12.7644 11.5958 12.4111 11.7729C12.0579 11.9411 11.5371 12.0249 10.8486 12.0249C10.4097 12.0249 10.0538 12.3809 10.0537 12.8198V13.436C10.0537 14.0213 10.528 14.4956 11.1133 14.4956H11.6729C11.9491 14.4954 12.1728 14.2719 12.1729 13.9956C12.1729 13.721 12.3952 13.5009 12.668 13.4692C13.3336 13.3919 13.8842 13.1674 14.3193 12.7954C14.8668 12.326 15.1406 11.6708 15.1406 10.8296C15.1406 9.92625 14.8582 9.23075 14.293 8.74365C13.7278 8.24778 12.977 8.00055 12.041 8.00049Z"
        fill="currentColor"
      />
    </svg>
  );
};
